import {enterpriseRole} from '../config/reactConfig';
import _ from 'lodash';
import {load} from 'cheerio';
import moment from 'moment';

const isValidUrl = url => {
  // Check if the URL is a valid URL
  try {
    if (!url.startsWith('https://') && !url.startsWith('http://')) {
      return false;
    }
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
};

const inlineToClass = (html, nonceId) => {
  const htmlCode = html ? html : '<div></div>';
  const $ = load(htmlCode);
  const styleMap = new Map();
  $('*').each((i, val) => {
    const inlineStyle = $(val).attr('style');
    if (inlineStyle) {
      const existingClassName = styleMap.get(inlineStyle);
      if (existingClassName) {
        $(val).addClass(existingClassName);
      } else {
        const className = `class-${i}`;
        styleMap.set(inlineStyle, className);
        $(val).addClass(className);
      }
      $(val).removeAttr('style');
    }
    // adding nonce attribute to style/script tag of html content
    if (val?.name === 'style' || val?.name === 'script') {
      $(val).attr('nonce', nonceId);
    }
  });
  const styleRules = Array.from(styleMap.entries()).map(
    ([style, className]) => `.${className} { ${style} }`
  );
  const deduplicatedStyleRules = _.uniq(styleRules);
  const styleTag = `<style nonce='${nonceId}'>${deduplicatedStyleRules.join('\n')}</style>`;
  $('body').append(styleTag);
  return $.html();
};

const cssVar = name => {
  // name = String(name);
  if (name.substr(0, 2) !== '--') {
    name = '--' + name;
  }
  return getComputedStyle(document.documentElement).getPropertyValue(name);
};

const validateTmoEmail = email => {
  const re = /^\w+([.-]?\w+)*@t-mobile\.com$/i;
  return re.test(email);
};

const validateDomainValue = domain => {
  if (domain && domain?.indexOf('www.') === -1) {
    const re = /^((?!-)[A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,10}$/i;
    return re.test(domain);
  } else {
    return false;
  }
};

const containsOnlySpecialCharacter = str => {
  if (str) {
    const re = /^[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~\d]*$/g;
    return re.test(str?.trim());
  } else {
    return false;
  }
};

const containsEmoji = str => {
  if (str) {
    const re = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
    return re.test(str?.trim());
  } else {
    return false;
  }
};

const containsOnlyNumber = str => {
  if (str) {
    const re = /^\d+$/;
    return re.test(str?.trim());
  } else {
    return false;
  }
};

const getFirstNameFromFull = name => {
  const splitName = name?.split(',');
  if ( splitName?.length > 1) {
    return splitName[1].trim();
  } else {
    return '';
  }
};

const getLastNameFromFull = name => {
  const splitName = name?.split(',');
  if ( splitName?.length > 0) {
    return splitName[0].trim();
  } else {
    return '';
  }
};

const toInitCapWithHyphen = (str) => {
  if (!str) return ''; 
  return str
    .split('-') 
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
    .join('-'); 
};

const roleOptions = [
  // eslint-disable-next-line max-len
  {name: 'Trusted Partner Admin', role: enterpriseRole.TRUSTED_PARTNER_ADMIN, description: 'Admin can add new users and can view documentation.'},
  // eslint-disable-next-line max-len
  {name: 'Trusted Partner Member', role: enterpriseRole.TRUSTED_PARTNER_MEMBER, description: 'Member can view documentation.'},
  {name: 'Trusted Partner Viewer', role: enterpriseRole.TRUSTED_PARTNER_VIEWER, description: 'Viewer can view documentation.'}
];


function decodeBase64Url(base64Url) {
  // Replace Base64URL specific characters
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  // Pad with '=' to make the length a multiple of 4
  const paddedBase64 = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
  // Decode Base64 string to regular string
  return decodeURIComponent(atob(paddedBase64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

function decodeJwt(token) {
  try {
    const [header, payload, signature] = token.split('.');
    const decodedHeader = JSON.parse(decodeBase64Url(header));
    const decodedPayload = JSON.parse(decodeBase64Url(payload));
  
    return {
      header: decodedHeader,
      payload: decodedPayload,
      signature: signature,
    }; 
  } catch (error) {
    console.log(error);
    return {};
  }
}

const formatDate = (date) => {
  return moment(date).format('DD MMM YYYY, h:mm A');
};

export {
  inlineToClass,
  validateDomainValue, 
  containsOnlySpecialCharacter, 
  containsEmoji, 
  containsOnlyNumber, 
  getFirstNameFromFull, 
  getLastNameFromFull,
  cssVar,
  isValidUrl,
  roleOptions,
  validateTmoEmail,
  toInitCapWithHyphen,
  decodeJwt,
  formatDate
};
